import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1b7e098"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "yidongxunjian-container" }
const _hoisted_2 = { class: "left-sidebar" }
const _hoisted_3 = { class: "right-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "记录编号：", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "巡检人：", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "记录编号：", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "巡检人：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_sidebar_item = _resolveComponent("van-sidebar-item")!
  const _component_van_sidebar = _resolveComponent("van-sidebar")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_sidebar, {
        modelValue: _ctx.activeKey,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebarchange(_ctx.activeKey)))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (li, index) => {
            return (_openBlock(), _createBlock(_component_van_sidebar_item, {
              key: index,
              title: li
            }, null, 8, ["title"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: _ctx.loading,
            "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
            finished: _ctx.finished,
            "finished-text": "没有更多了",
            "loading-text": "正在加载,请稍后..",
            onLoad: _ctx.onLoad
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.xunJianPointList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list",
                  key: index
                }, [
                  _createElementVNode("div", null, "巡检点：" + _toDisplayString(item.pointName), 1),
                  _createElementVNode("div", null, [
                    _hoisted_4,
                    _createElementVNode("span", null, _toDisplayString(item.recordNo), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_5,
                    _createElementVNode("span", null, _toDisplayString(item.createName), 1)
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished", "onLoad"])
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"]), [
        [_vShow, _ctx.activeKey === 0]
      ]),
      _withDirectives(_createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh1
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: _ctx.loading1,
            "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loading1) = $event)),
            finished: _ctx.finished1,
            "finished-text": "没有更多了",
            "loading-text": "正在加载,请稍后..",
            onLoad: _ctx.onLoad1
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.xunJianWayList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list",
                  key: index
                }, [
                  _createElementVNode("div", null, "巡检路线：" + _toDisplayString(item.wayName), 1),
                  _createElementVNode("div", null, [
                    _hoisted_6,
                    _createElementVNode("span", null, _toDisplayString(item.recordNo), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_7,
                    _createElementVNode("span", null, _toDisplayString(item.userName), 1)
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished", "onLoad"])
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"]), [
        [_vShow, _ctx.activeKey === 1]
      ])
    ])
  ]))
}